import {categories} from './techniques';

// Nombre legible de cada sección de la app (la usan las métricas y los comentarios).
const MODULE_LABELS={
  ...Object.fromEntries(categories.map(category=> [category.id,category.label])),
  home: 'Inicio',
  eventos: 'Eventos',
  entrenamiento: 'Entrenamiento',
  perfil: 'Perfil',
  usuarios: 'Usuarios',
  'admin-eventos': 'Admin eventos',
  metricas: 'Métricas',
  comentarios: 'Comentarios',
};

export const moduleLabel=(id)=> MODULE_LABELS[id] || id;
